import {combineReducers} from 'redux';import menu from "./menu"const rootReducer = combineReducers({    name: menu});export default rootReducer;